
import {defineComponent} from "vue"

/*
    Handles PWA logic (caching, service workers, etc.)
*/
export default defineComponent({
    data() {
        return {
            registration: null as ServiceWorkerRegistration | null,
            refreshing: false
        }
    },

    created() {
        document.addEventListener("sw-updated", e => this.updateAvailable(e as CustomEvent), {once: true})
        if (navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener("controllerchange", () => this.reloadContent())
        }
    },

    methods: {
        updateAvailable(event: CustomEvent) {
            this.registration = event.detail

            this.refreshApp()
        },

        refreshApp() {
            if (!this.registration || !this.registration.waiting) return

            this.registration.waiting.postMessage({type: "SKIP_WAITING"})
        },

        reloadContent() {
            if (this.refreshing) return
            this.refreshing = true

            window.location.reload()
        }
    }
})
